import {
   Dialog,
   DialogContent,
   DialogDescription,
   DialogHeader,
   DialogTitle
} from "@/components/ui/dialog";
import { format } from 'date-fns';

const ViewRemarksModal = ({ isOpen, onClose, application }) => {
   // useEffect(() => {
   //    if (application) {
   //       console.log('Application data in ViewRemarksModal:', application);
   //       console.log('History data:', application.history);
   //    }
   // }, [application]);

   const formatDate = (timestamp) => {
      const date = new Date(parseInt(timestamp));
      return format(date, 'MMM d, yyyy h:mm aa');
   };

   if (!application) return null;

   // Get all return remarks from history, sorted by most recent first
   const returnRemarks = application.history
      ?.filter(entry =>
         entry.stage?.toLowerCase().includes('return') ||
         entry.status?.toLowerCase() === 'returned'
      )
      .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

   // console.log('Filtered return remarks:', returnRemarks);

   // remove this function before deploying
   const getReturnedBy = (remark) => {
      const stage = remark.stage?.toLowerCase() || '';
      if (stage.includes('technical')) return 'Technical Staff';
      if (stage.includes('receiving')) return 'Receiving Clerk';
      if (stage.includes('penr') || stage.includes('cenr')) return 'PENR/CENR Officer';
      return 'Staff';
   };

   return (
      <Dialog open={isOpen} onOpenChange={onClose}>
         <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
               <DialogTitle>Return Remarks</DialogTitle>
               <DialogDescription>
                  Review the remarks for application {application.applicationNumber}
               </DialogDescription>
            </DialogHeader>
            <div className="mt-4">
               {returnRemarks && returnRemarks.length > 0 ? (
                  <div className="space-y-4">
                     {returnRemarks.map((remark, index) => (
                        <div key={index} className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                           <div className="mb-2 flex justify-between items-start">
                              <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                 {getReturnedBy(remark)}
                              </span>
                              <span className="text-sm text-gray-400 dark:text-gray-500">
                                 {formatDate(remark.timestamp)}
                              </span>
                           </div>
                           <p className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap mt-2">
                              {remark.notes || 'No additional remarks provided.'}
                           </p>
                           <div className="mt-2 text-xs text-gray-400 dark:text-gray-500">
                              Stage: {remark.stage}
                           </div>
                        </div>
                     ))}
                  </div>
               ) : (
                  <p className="text-sm text-gray-700 dark:text-gray-300">No return remarks found.</p>
               )}
            </div>
         </DialogContent>
      </Dialog>
   );
};

export default ViewRemarksModal;
